import React, { createContext, useContext, useState } from "react";
import Toast from "../components/Toast";

const ModalContext = createContext();

const ModalContextProvider = (props) => {
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [visible, setVisible] = useState(false);
  const [autoClose, setAutoClose] = useState(0);

  const showModal = (msg, type = "info", ac = 0) => {
    setAutoClose(ac);
    setMessage(msg);
    setSeverity(type);
    setVisible(true);
  };

  return (
    <ModalContext.Provider value={{ showModal }}>
      <Toast
        message={message}
        visible={visible}
        severity={severity}
        autoClose={autoClose}
        onClose={() => setVisible(false)}
      />
      {props.children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);

export default ModalContextProvider;
